module.exports = __webpack_public_path__ + "img/050.74d50d73.jpg";